export interface StateLabels {
  errorTitle: string
  errorMessage: (error: unknown) => string
  emptyTitle: string
  emptyDescription: string
}

export const DEFAULT_STATE_LABELS: StateLabels = {
  errorTitle: 'Something went wrong',
  errorMessage: (error: unknown): string => {
    if (error instanceof Error) return error.message
    if (typeof error === 'string') return error
    if (error && typeof error === 'object' && 'message' in error) {
      return String((error as { message: unknown }).message)
    }
    return 'Unknown error'
  },
  emptyTitle: 'No data',
  emptyDescription: 'Try adjusting filters or wait for data to load.',
}
